import axios from "axios";

// added comment to trigger rebuild in aws amplify

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

export default instance;